<div [id]="nodeId" class="chart bar">&nbsp;</div>